import { useState, useEffect } from 'react';

function VerifyEmail() {
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link.');
      return;
    }

    fetch((process.env.REACT_APP_API_URL || '') + '/api/auth/verify-email?token=' + token)
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          setStatus('error');
          setMessage(data.error);
        } else {
          setStatus('success');
          setMessage(data.message);
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Something went wrong. Please try again.');
      });
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {status === 'verifying' && (
          <>
            <h1 style={styles.title}>Verifying your email...</h1>
            <p style={styles.body}>Please wait a moment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <h1 style={{ ...styles.title, color: '#2e7d32' }}>Email verified</h1>
            <p style={styles.body}>{message}</p>
            <a href="/" style={styles.button}>Sign in now</a>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 style={{ ...styles.title, color: '#c0392b' }}>Verification failed</h1>
            <p style={styles.body}>{message}</p>
            <a href="/" style={styles.link}>Back to sign in</a>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5' },
  card: { backgroundColor: '#fff', padding: '40px', borderRadius: '8px', width: '100%', maxWidth: '400px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', textAlign: 'center' },
  title: { fontSize: '24px', fontWeight: '700', color: '#1a1a1a', marginBottom: '12px' },
  body: { fontSize: '15px', color: '#444', lineHeight: 1.6, marginBottom: '24px' },
  button: { display: 'block', padding: '12px', backgroundColor: '#c0392b', color: '#fff', borderRadius: '4px', textDecoration: 'none', fontWeight: '600', fontSize: '15px' },
  link: { fontSize: '14px', color: '#c0392b' },
};

export default VerifyEmail;
